import type { Program } from "../types";
import { ProgramCreate } from "./ProgramCreate";
import { ProgramEdit } from "./ProgramEdit";
import { ProgramList } from "./ProgramList";
import { ProgramShow } from "./ProgramShow";

export { programsMessages } from "./programsMessages";

export default {
  list: ProgramList,
  create: ProgramCreate,
  edit: ProgramEdit,
  show: ProgramShow,
  recordRepresentation: (record: Program) => record.name,
};
